import React from 'react';

// FundPot logomark — animated coin dropping into the pot. Shared by Home + Fund.
export default function LogoMark({ size = 44, animate = true }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"
      role="img" aria-label="FundPot"
      style={{ borderRadius: size * 0.24, display: 'block', boxShadow: '0 8px 26px rgba(43,227,164,0.28)' }}
    >
      <defs>
        <linearGradient id="bgGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#10301F" />
          <stop offset="1" stopColor="#071510" />
        </linearGradient>
        <linearGradient id="potGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#22E6A6" />
          <stop offset="1" stopColor="#12B385" />
        </linearGradient>
        <radialGradient id="coinGrad" cx="0.4" cy="0.35" r="0.8">
          <stop offset="0" stopColor="#FCE27E" />
          <stop offset="1" stopColor="#DB9C2C" />
        </radialGradient>
      </defs>

      <rect width="100" height="100" rx="24" fill="url(#bgGrad)" />

      {/* Coin (drawn behind the pot so it slides in). SMIL animation —
          works reliably in Safari, unlike CSS transforms on SVG groups. */}
      <g>
        {animate && (
          <>
            <animateTransform attributeName="transform" attributeType="XML" type="translate"
              dur="2.2s" repeatCount="indefinite"
              keyTimes="0;0.14;0.62;0.82;1"
              values="0 -24;0 -22;0 12;0 22;0 22"
              calcMode="spline"
              keySplines="0.4 0 0.8 0.4;0.4 0 0.85 0.5;0.5 0 1 1;0 0 1 1" />
            <animate attributeName="opacity"
              dur="2.2s" repeatCount="indefinite"
              keyTimes="0;0.14;0.62;0.82;1"
              values="0;1;1;0;0" />
          </>
        )}
        <circle cx="50" cy="30" r="12.5" fill="url(#coinGrad)" stroke="#C5851C" strokeWidth="1.6" />
        <text x="50" y="35.5" textAnchor="middle" fontSize="15" fontWeight="800"
              fill="#7A5410" fontFamily="-apple-system, Helvetica, sans-serif">$</text>
      </g>

      {/* Pot (drawn in front so the coin disappears into it) */}
      <g className="pot-bounce">
        <rect x="26" y="52" width="48" height="9" rx="4.5" fill="url(#potGrad)" />
        <path d="M30 60 H70 L62.5 84 Q62 86 59.5 86 H40.5 Q38 86 37.5 84 Z" fill="url(#potGrad)" />
      </g>
    </svg>
  );
}
